module.exports = __webpack_public_path__ + "img/poker-c13.4eab7d49.svg";